var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVip)?_c('v-icon',{attrs:{"color":"#FFC800","size":_vm.size}},[_vm._v(" mdi-crown ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }